const clean = (value) => String(value || '').trim().replace(/\s+/g, ' ');
const tokens = (value) => clean(value).toLowerCase().split(/\s+/).filter(Boolean);

const labelCoversContext = (label, context) => {
  const contextTokens = tokens(context);
  if (contextTokens.length === 0) return true;
  const labelTokens = new Set(tokens(label));
  return contextTokens.every((token) => labelTokens.has(token));
};

export function buildContextualProductInput({ label, productContext, brand } = {}) {
  const variantLabel = clean(label);
  const context = clean(productContext);
  const brandName = clean(brand);
  if (!variantLabel) return context || brandName;
  if (context && labelCoversContext(context, variantLabel)) return context;

  const pieces = [];
  const variantLower = variantLabel.toLowerCase();
  const contextLower = context.toLowerCase();
  if (
    brandName &&
    !variantLower.includes(brandName.toLowerCase()) &&
    !contextLower.includes(brandName.toLowerCase())
  ) {
    pieces.push(brandName);
  }
  if (context && !variantLower.includes(context.toLowerCase()) && !labelCoversContext(variantLabel, context)) {
    pieces.push(context);
  }
  pieces.push(variantLabel);

  return pieces.join(' ').replace(/\s+/g, ' ').trim();
}
